<template>
  <div class="match-com" v-if="visible">
    <div class="match-logo flex-middle">
      <img :src="require('@/assets/img/guessing-management/match-t.png')" />
    </div>
    <div class="close" @click="close"><img :src="require('@/assets/img/guessing-management/match-close.png')" /></div>
    <div class="match-com-top flex-middle">
      <div class="quession">{{ data.title }}</div>
    </div>
    <div class="match-com-ll flex-row flex-between">
      <div class="jackpot">奖池：{{ data.amount_list[0] + data.amount_list[1] }}</div>
      <CountDown color="#02A8A2" :beforeTimeContent="'倒计时'" fontSize=".14rem" :endTime="data.endTime"></CountDown>
    </div>

    <div class="match-com-body flex-between align-center">
      <div class="item-body flex-row align-center">
        <div class="logo">
          <img :src="require('@/assets/img/guessing-management/match-logo-5.png')" />
        </div>
        <div class="s">(倍数：{{ data.odds_list[0] }})</div>
      </div>
      <div class="vs"><img :src="require('@/assets/img/guessing-management/match-vs-3.png')" /></div>
      <div class="item-body flex-row align-center">
        <div class="s">(倍数：{{ data.odds_list[1] }})</div>
        <div class="logo">
          <img :src="require('@/assets/img/guessing-management/match-logo-6.png')" />
        </div>
      </div>
    </div>

    <div class="match-progress">
      <div class="item-progress">
        <el-progress :text-inside="true" :stroke-width="9" :percentage="data.progress_list[0]"></el-progress>
        <div class="item-s" :style="{ left: data.progress_list[0] + '%' }">
          <img :src="require('@/assets/img/guessing-management/match-s.png')" />
        </div>
      </div>
      <!--
			<div class="item-progress">
				<el-progress :text-inside="true" :stroke-width="6" :percentage="data.progress_list[1]"></el-progress>
			</div>
			-->
    </div>

    <div class="match-money flex-between">
      <div class="left">
        <div class="item-desc">{{ data.people_num_list[0] }}人/{{ data.amount_list[0] }}鹰钻</div>
      </div>
      <div class="right">
        <div class="item-desc">{{ data.people_num_list[1] }}人/{{ data.amount_list[1] }}鹰钻</div>
      </div>
    </div>

    <div class="match-answer flex-column align-center">
      <div class="answer-item">
        <div class="t flex-middle" @click="toBet(1)">{{ data.contentArr[0] }}</div>
      </div>
      <div class="answer-item">
        <div class="t flex-middle select" @click="toBet(2)">{{ data.contentArr[1] }}</div>
      </div>
    </div>
    <div class="match-btn flex-middle">
      <div class="vs-btn" @click="continueBet">继续鹰选</div>
    </div>
  </div>
</template>

<script>
import CountDown from "@/components/count-down/CountDown";
import { mapState, mapMutations } from "vuex";
export default {
  props: {},
  components: {
    CountDown,
  },

  data() {
    return {
      data: {},
      visible: false,
      timeT: null,
      selectIndex: "",
    };
  },
  destroyed() {
    this.timeT && clearInterval(this.timeT);
  },
  methods: {
    open(item = {}) {
      this.visible = true;
      this.data = item;
      this.listenStatus();
      console.log("item: ", item);
    },

    close() {
      this.visible = false;
      this.selectIndex = "";
      this.timeT && clearInterval(this.timeT);
      if (this.data.g_id) {
        this.$emit("changeShowGuessList", this.data.g_id);
      }
      this.data = {};
    },
    listenStatus() {
      this.timeT && clearInterval(this.timeT);
      this.timeT = setInterval(() => {
        let { status = "", endTime = "" } = this.data;
        if (status && endTime && status == 1 && endTime > new Date()) {
        } else {
          this.visible = false;
          this.$emit("continueBet");
        }
      }, 3000);
    },
    toBet(result = 0) {
      this.selectIndex = result;
      this.$emit("toBet", { ...this.data, result });
    },
    continueBet() {
      this.$emit("continueBet");
    },
  },
};
</script>

<style lang="scss" scoped>
.match-com {
  width: 4.3rem;
  position: absolute;
  left: 0rem;
  bottom: 0.52rem;
  z-index: 1001;
  font-size: 0.15rem;
  // background: url(../../assets/img/guessing-management/match-bline.png) no-repeat;
  // background-size : 100% 100%;
  padding: 0.2rem 0rem;
  border-image: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
  background-clip: padding-box, border-box;
  background-origin: padding-box, border-box;
  background-image: linear-gradient(to right, #fff, #fff), linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
  border: 0.04rem solid transparent;
  border-radius: 0.16rem;
  .close {
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
    cursor: pointer;
    color: #bfd1d0;
    img {
      width: 0.14rem;
    }
  }

  .match-logo {
    position: absolute;
    top: -0.2rem;
    left: 50%;
    transform: translateX(-50%);
    img {
      width: 0.6rem;
    }
  }

  .match-com-top {
    padding-top: 0.15rem;
    .quession {
      padding: 0.05rem;
      font-size: 0.18rem;
      line-height: 0.25rem;
      color: #333333;
    }
  }

  .match-com-ll {
    line-height: 0.2rem;
    padding: 0.1rem 0.2rem;
    margin: 0.2rem 0rem;
    background: rgba(29, 217, 183, 0.1);
    .jackpot {
      color: #666666;
      font-size: 0.14rem;
    }
  }
  .match-com-body {
    padding: 0.1rem 0.3rem;
    .logo {
      height: 0.5rem;
      width: 0.5rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .vs {
      margin: 0rem 0.1rem;
      img {
        height: 0.2rem;
      }
    }
    .s {
      font-size: 0.1rem;
      color: #666666;
      padding: 0rem 0.06rem;
    }

    .vs-team {
      padding: 0.2rem 0rem;
      .item-desc {
        color: #f4f5f8;
        font-size: 0.14rem;
        padding: 0.12rem 0rem;
      }
      .item-body {
        height: 0.7rem;
        width: 1.4rem;
        background: #2c3e4c;
        border-radius: 3px;
        position: relative;

        .t {
          font-size: 0.2rem;
        }
      }
      .left {
        cursor: pointer;
        &:hover,
        &.select {
          .item-body {
            background: #235e8a;
          }
          .t {
            color: #ffffff;
          }
        }
        .logo {
          left: -0.35rem;
        }
        ::v-deep {
          .el-progress-bar__inner {
            background: linear-gradient(90deg, #635fff 0.18%, #68bfff 100.18%);
          }
        }
        .t {
          color: #3c9cfe;
        }
      }
      .right {
        &:hover,
        &.select {
          .item-body {
            background: #238a84;
          }
          .t {
            color: #ffffff;
          }
        }
        cursor: pointer;
        .logo {
          right: -0.35rem;
        }
        .item-progress {
          transform: rotateY(180deg);
        }
        ::v-deep {
          .el-progress-bar__inner {
            background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
          }
        }
        .t {
          color: #02a8a2;
        }
      }
    }
  }

  .match-money {
    padding: 0rem 0.3rem;
    color: #999999;
  }

  .match-answer {
    padding: 0.1rem 0.3rem;
    .answer-item {
      margin: 0.03rem 0rem;
      width: 80%;
    }
    .t {
      cursor: pointer;
      height: 0.34rem;
      background: linear-gradient(90deg, #29f19e 0%, #00c2ff 100%);
      border-radius: 1rem;
      color: #ffffff;
      &.select {
        background: linear-gradient(90deg, #03a2f9 0%, #0357f9 98.24%);
      }
    }
  }

  .match-progress {
    margin: 0rem 0.3rem;
    margin-bottom: 0.08rem;
    z-index: 1;
    position: relative;
    ::v-deep {
      .el-progress-bar__innerText {
        display: none;
      }
      .el-progress-bar__outer {
        background: linear-gradient(90deg, #29f19e 0%, #00c2ff 100%);
      }
      .el-progress-bar__inner {
        background: transparent;
      }
    }
    .item-s {
      position: absolute;
      left: 0%;
      transform: translate(-50%, -50%);
      top: 50%;
      z-index: 100;
      img {
        height: 0.4rem;
      }
    }
  }
  .match-btn {
    margin: 0.1rem 0rem;
    .vs-btn {
      cursor: pointer;
      color: #999999;
    }
  }
}
</style>
